import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = {
  key: 0,
  class: "loading-text"
}
const _hoisted_4 = { class: "product-links" }
const _hoisted_5 = { class: "link-image" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "product-link-card placeholder-card" }
const _hoisted_8 = { class: "link-image" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "product-link-card placeholder-card" }
const _hoisted_11 = { class: "link-image" }
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ImageCarousel = _resolveComponent("ImageCarousel")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Главная", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, " → ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Продукция", -1))
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "page-title" }, "Продукция", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "intro-text" }, " Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ", -1)),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Загрузка..."))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.products.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.products, (product) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: product.id,
                  to: `/products/${product.slug}`,
                  class: "product-link-card",
                  onClick: ($event: any) => (_ctx.onProductClick(product))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      (product.photo_urls && product.photo_urls.length > 0)
                        ? (_openBlock(), _createBlock(_component_ImageCarousel, {
                            key: 0,
                            images: product.photo_urls,
                            alt: product.name,
                            height: "150px"
                          }, null, 8, ["images", "alt"]))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.placeholderImg,
                            alt: ""
                          }, null, 8, _hoisted_6))
                    ]),
                    _createElementVNode("h3", null, _toDisplayString(product.name), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "link-arrow" }, "Подробнее →", -1))
                  ]),
                  _: 2
                }, 1032, ["to", "onClick"]))
              }), 128))
            : _createCommentVNode("", true),
          (!_ctx.loading && _ctx.products.length === 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.placeholderImg,
                      alt: ""
                    }, null, 8, _hoisted_9)
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("h3", null, "Lorem ipsum dolor sit amet consectetur", -1)),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "link-arrow" }, "Подробнее →", -1))
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      src: _ctx.placeholderImg,
                      alt: ""
                    }, null, 8, _hoisted_12)
                  ]),
                  _cache[6] || (_cache[6] = _createElementVNode("h3", null, "Lorem ipsum dolor sit amet", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "link-arrow" }, "Подробнее →", -1))
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}